export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7270.b5bb2b0a.jpg";